module.exports = __webpack_public_path__ + "static/fonts/Sansation-Bold-webfont.19fe9dc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sansation/Sansation-Bold-webfont.woff
// module id = NZkQ
// module chunks = 0